import { CounterpartyForm } from './components/form';
import { Counterparties } from './components/table';

import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_COUNTERPARTY,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

export const states = [
  {
    name: 'base-layout.counterparties',
    url: '/counterparties',
    component: Counterparties,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COUNTERPARTY, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.counterparties.create',
    url: '/new',
    component: CounterpartyForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COUNTERPARTY, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.counterparties.edit',
    url: '/:counterpartyId/edit',
    component: CounterpartyForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_COUNTERPARTY, PERMISSION_UPDATE]],
    },
  },
];
